import { NgModule } from '@angular/core';
import { FiAppearanceAvailableWidgetsListComponent } from './available-widgets-list.component';
import { CommonModule } from '@angular/common';
import { FiSharedWidgetModule } from '@fi-shared/widget/widget.module';
import { DndModule } from 'ngx-drag-drop';
import { FiAppTextSharedModule } from '@fi-shared/app-text';

@NgModule({
    imports: [CommonModule, FiSharedWidgetModule, DndModule, FiAppTextSharedModule],
    declarations: [FiAppearanceAvailableWidgetsListComponent],
    exports: [FiAppearanceAvailableWidgetsListComponent],
})
export class FiAppearanceAvailableWidgetsListModule {}
